import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import TitleForm from "../formComponent/titleForm";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { BoxImage } from "../boxImage/boxImage";
import ClearIcon from "@mui/icons-material/Clear";
import { getImage } from "../../../service/upload/getImage";
import {
  UseConvertImageToBase64,
  isImageNotFound,
} from "../../hooks/use-convert-image-to-base-64";

export function ProductDialog({ props }) {
  let {
    menuType,
    productAll,
    setProductAll,
    dataAllProduct,
    setDataAllProduct,
    setDialogProduct,
    dialogProduct,
  } = props;
  const [productType, setProductType] = useState(dataAllProduct[0]?.id);
  const [search, setSearch] = useState("");
  const { t } = useTranslation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const visibleCategories = dataAllProduct
    .filter((cate) => cate.show === true)
    .sort((a, b) => a.id - b.id);
  // productType starts as undefined when the list loads after mount; fall back
  // to the first category so the dialog never opens on an empty panel.
  const activeType = visibleCategories.some((cate) => cate.id === productType)
    ? productType
    : visibleCategories[0]?.id;
  const activeCategory = dataAllProduct.find((cate) => cate.id === activeType);
  const visibleProducts =
    activeCategory?.show === true
      ? activeCategory.product
          .map((product, indexProduct) => ({ product, indexProduct }))
          .filter(({ product }) => product.show === true)
      : [];
  const totalSelected = dataAllProduct.reduce(
    (sum, cate) => sum + (cate.amount || 0),
    0
  );
  const handleProductType = (productType) => {
    setProductType(productType.id);
  };
  const handleProductTypeMobile = (e) => {
    setProductType(e.target.value);
  };
  const handleAmount = (item, indexProduct, productCate, status) => {
    if (menuType === 1) {
      setDataAllProduct((prevData) => {
        const newData = [...prevData];
        newData.forEach((cate) => {
          cate.amount = 0;
          cate.product.forEach((product) => {
            product.amount = 0;
          });
        });
        const targetCate = newData.find(
          (itemCate) => itemCate.id === productCate.id
        );
        if (targetCate?.product?.[indexProduct]) {
          targetCate.product[indexProduct].amount =
            status === "increase" ? 1 : 0;
        }
        newData.forEach((cate) => {
          cate.amount = 0;
          cate.product.forEach((product) => (cate.amount += product.amount));
        });
        return newData;
      });
    } else {
      if (item.amount >= 0) {
        setDataAllProduct((prevData) => {
          const newData = [...prevData];
          const targetCate = newData.find(
            (itemCate) => itemCate.id === productCate.id
          );
          if (targetCate?.product?.[indexProduct]) {
            targetCate.product[indexProduct].amount +=
              status === "increase" ? 1 : item.amount === 0 ? 0 : -1;
          }
          newData.forEach((cate) => {
            cate.amount = 0;
            cate.product.forEach((product) => (cate.amount += product.amount));
          });
          return newData;
        });
      }
    }
  };

  const handleClear = () => {
    setSearch("");
    let dataSearch = "";
    setDataAllProduct((prevData) => {
      const newData = prevData.map((cate) => {
        const newProduct = cate.product.map((product) => {
          const productName = product.data.product_lang.name.toUpperCase();
          product.show = !dataSearch || productName.includes(dataSearch);
          return product;
        });
        cate.show = !dataSearch || newProduct.some((product) => product.show);
        return { ...cate, product: newProduct };
      });
      if (newData.filter((item) => item.show === true).length > 0) {
        setProductType(newData.filter((item) => item.show === true)[0].id);
      }
      return newData;
    });
  };

  const handleSearchProduct = async (e) => {
    const dataSearch = e.target.value.toUpperCase();
    setSearch(e.target.value);
    setDataAllProduct((prevData) => {
      const newData = prevData.map((cate) => {
        const newProduct = cate.product.map((product) => {
          const productName = product.data.product_lang.name.toUpperCase();
          product.show = !dataSearch || productName.includes(dataSearch);
          return product;
        });
        cate.show = !dataSearch || newProduct.some((product) => product.show);
        return { ...cate, product: newProduct };
      });
      if (newData.filter((item) => item.show === true).length > 0) {
        setProductType(newData.filter((item) => item.show === true)[0].id);
      }
      return newData;
    });
  };
  const onConfirmProduct = async () => {
    let dataConfirm = [];
    let count = 0;
    dataAllProduct.forEach(async (cate) => {
      cate.show = true;

      cate.product.forEach(async (product) => {
        if (
          product.data.image.includes("data:image") === false &&
          !isImageNotFound(product.data.image)
        ) {
          let imageUrl = await getImage(product.data.image);
          product.data.image = await UseConvertImageToBase64(imageUrl);
        }
        product.show = true;
        if (product.amount > 0) {
          dataConfirm.push({
            id: product.id,
            amount: product.amount,
            name: product.data.product_lang.name,
            image: product.data.image,
          });
        }
      });
      count++;
      if (count === dataAllProduct.length) {
        await handleClear()
        await setProductAll(dataConfirm);
        await setDialogProduct(false);
      }
    });
  };
  const onClose = () => {
    setSearch("");
    setTimeout(() => {
      dataAllProduct.forEach((cate) => {
        cate.amount = 0;
        cate.show = true;
        if (cate.product.length > 0) {
          cate.product.forEach((product) => {
            product.show = true;
            if (productAll?.length > 0) {
              productAll.forEach((itemProductAll) => {
                if (itemProductAll.id === product.id) {
                  product.amount = itemProductAll.amount;
                  cate.amount += itemProductAll.amount;
                } else {
                  product.amount = 0;
                }
              });
            } else {
              product.amount = 0;
            }
          });
        }
      });
    }, 500);
    setDialogProduct(false);
  };
  const renderStepper = (product, indexProduct, size) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Fab
        sx={{ boxShadow: 0 }}
        aria-label="decrease"
        size={size}
        disabled={product.amount === 0}
        onClick={() =>
          handleAmount(product, indexProduct, activeCategory, "decrease")
        }
      >
        <RemoveIcon />
      </Fab>
      <Typography
        sx={{ fontFamily: "Kanit", minWidth: 24, textAlign: "center" }}
      >
        {product.amount}
      </Typography>
      <Fab
        sx={{ boxShadow: 0 }}
        aria-label="increase"
        color={product.amount > 0 ? "primary" : "default"}
        size={size}
        onClick={() =>
          handleAmount(product, indexProduct, activeCategory, "increase")
        }
      >
        <AddIcon />
      </Fab>
    </Box>
  );

  const searchField = (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: search && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClear} edge="end">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      value={search}
      onChange={handleSearchProduct}
      placeholder={t("global_search_product")}
      size="small"
      fullWidth
    />
  );

  const emptyState = (
    <Box sx={{ width: "100%", textAlign: "center", p: 3 }}>
      <Typography color="text.secondary">
        {t("global_data_not_found")}
      </Typography>
    </Box>
  );

  return (
    <Dialog
      open={dialogProduct}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      onClose={onClose}
    >
      <DialogTitle align="center" sx={{ pb: { xs: 1, sm: 2 } }}>
        <Typography variant={isMobile ? "h6" : "h5"}>
          {t("product_add_product")}
        </Typography>
      </DialogTitle>
      {isMobile ? (
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            px: 2,
            pt: "8px !important",
          }}
        >
          <Select
            fullWidth
            size="small"
            value={activeType ?? ""}
            onChange={handleProductTypeMobile}
            displayEmpty
          >
            {visibleCategories.map((cate) => (
              <MenuItem key={cate.id} value={cate.id}>
                {cate.name}
                {cate.amount > 0 ? ` (${cate.amount})` : ""}
              </MenuItem>
            ))}
          </Select>
          {searchField}
          <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", mx: -2 }}>
            {visibleProducts.length === 0
              ? emptyState
              : visibleProducts.map(({ product, indexProduct }) => (
                  <Box
                    key={product.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      px: 2,
                      py: 1,
                      borderBottom: "1px solid #F1F1F1",
                      backgroundColor:
                        product.amount > 0 ? "action.hover" : "transparent",
                    }}
                  >
                    <Box sx={{ width: 64, height: 64, flexShrink: 0 }}>
                      <BoxImage
                        image={product.data.image}
                        height={"64px"}
                        width={"64px"}
                        type="table"
                        borderRadius={true}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: "Kanit",
                        flex: 1,
                        minWidth: 0,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        wordBreak: "break-word",
                      }}
                    >
                      {product.data.product_lang.name}
                    </Typography>
                    {renderStepper(product, indexProduct, "small")}
                  </Box>
                ))}
          </Box>
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container justifyContent={"space-between"} pt={1}>
            <Grid item sm={2.8}>
              <TitleForm props={{ text: t("product_category") }} />
              <Box sx={{ maxHeight: "50vh", overflowY: "auto" }}>
                {visibleCategories.map((cate) => (
                  <Box
                    key={cate.id}
                    sx={(theme) => ({
                      width: "100%",
                      borderBottom: "1px solid #cccccc",
                      p: 2,
                      boxSizing: "border-box",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      backgroundColor:
                        activeType === cate.id
                          ? theme.palette.primary.main
                          : null,
                      color: activeType === cate.id ? "#ffffff" : null,
                    })}
                    onClick={() => handleProductType(cate)}
                  >
                    <Typography sx={{ fontWeight: 600 }}>{cate.name}</Typography>
                    {cate.amount > 0 && (
                      <Box
                        sx={(theme) => ({
                          p: 1,
                          backgroundColor: theme.palette.secondary.main,
                          color: theme.palette.white.main,
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          textAlign: "center",
                          lineHeight: 0,
                          placeItems: "center",
                          display: "grid",
                        })}
                      >
                        {cate.amount}
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            </Grid>
            <Grid item sm={9}>
              {searchField}
              <Grid
                container
                alignContent="flex-start"
                sx={{ height: "50vh", overflow: "auto" }}
              >
                {visibleProducts.length === 0
                  ? emptyState
                  : visibleProducts.map(({ product, indexProduct }) => (
                      <Grid
                        item
                        key={product.id}
                        xs={12}
                        md={6}
                        align="center"
                        sx={{ boxSizing: "border-box", p: 1 }}
                      >
                        <Grid container sx={{ boxShadow: 1, borderRadius: 1 }}>
                          <Grid item xs={6}>
                            <BoxImage
                              image={product.data.image}
                              height={200}
                              type="table"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{ display: "grid", placeItems: "center", p: 1 }}
                          >
                            <Typography sx={{ fontFamily: "Kanit" }}>
                              {product.data.product_lang.name}
                            </Typography>
                            {renderStepper(product, indexProduct, "small")}
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      )}
      <DialogActions
        sx={{
          px: { xs: 2, sm: 3 },
          py: 2,
          gap: 1,
          borderTop: isMobile ? "1px solid #F1F1F1" : "none",
        }}
      >
        <Button
          size="large"
          variant="outlined"
          onClick={() => onClose()}
          sx={{ borderRadius: 2, flex: { xs: 1, sm: "none" } }}
        >
          {t("cancel_button")}
        </Button>
        <Button
          size="large"
          variant="contained"
          onClick={() => onConfirmProduct()}
          sx={{ borderRadius: 2, flex: { xs: 1, sm: "none" } }}
        >
          {t("confirm_button")}
          {totalSelected > 0 ? ` (${totalSelected})` : ""}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
